/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CondizioneDTO { 
    id?: string;
    dimensione?: CondizioneDTODimensioneEnum;
    operatore?: CondizioneDTOOperatoreEnum;
    valore_decimale?: number;
    valore_decimale_max?: number;
    valore_intero?: number;
    valore_intero_max?: number;
    valore_booleano?: boolean;
    valore_stringa?: string;
}
export enum CondizioneDTODimensioneEnum {
    VALORE_ISEE = 'VALORE_ISEE',
    POSSESSO_ISEE = 'POSSESSO_ISEE',
    RESIDENZA = 'RESIDENZA',
    ORDINAMENTO = 'ORDINAMENTO',
    ORDINE_BENEFICIARIO = 'ORDINE_BENEFICIARIO',
    NUMERO_BENEFICIARI = 'NUMERO_BENEFICIARI'
};
export enum CondizioneDTOOperatoreEnum {
    EQ = 'EQ',
    LTE = 'LTE',
    RANGE = 'RANGE',
    IN = 'IN'
};



